import { suggestions } from "./suggestions";
import { getWithExpiry, setWithExpiry } from "./utils";
import axios from "axios"
import LZString from "lz-string"

const compressForStorage = (data) => {
  return LZString.compressToUTF16(JSON.stringify(data));
};

const decompressFromStorage = (compressed) => {
  return JSON.parse(LZString.decompressFromUTF16(compressed));
};

const retrieveJsonData = async (fileName, basePath) => {
  if (!basePath) {
    if (fileName.includes("landingPage.quicktip.json") || fileName.includes("landingPage.common.json")) {
      basePath = global.config.AEM_API_BASE_PATH;
    } else {
      basePath = global.config.AEM_URL;
    }
  }
  try {
    console.log("global.config");
    console.log(global.config);
    const cached = getWithExpiry(fileName);
    if(cached != null) {
      if (fileName.includes("landingPage.quicktip.json")) {
        return decompressFromStorage(cached);
      }
      return cached;
    } else {
      let response = await fetch(basePath + fileName);
      console.log('response---->', response);
      let responseJson = await response.json();
      if (fileName.includes("landingPage.quicktip.json")) {
        const compressed = compressForStorage(responseJson);
        setWithExpiry(fileName, compressed, 10800000, new Date().getTime() + 10800000);
      } else {
        setWithExpiry(fileName, responseJson, 10800000, new Date().getTime() + 10800000);
      }
      return responseJson;
    }
  } catch (error) {
    console.error(error);
    // Adding Json data in local store for file having error with expiry as 2 minutes 
    setWithExpiry(fileName, null, 120000, new Date().getTime() + 120000);
    return null;
  }
};

const retrieveFileData = async (fileName) => {
  try {
    console.log("global.config");
    console.log(global.config);
    let response = await fetch(fileName);
    console.log('response---->', response);
    let responseJson = await response.text();
    let responseForFile = {payload: responseJson, fileName: fileName};
    return responseForFile;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const retrieveAdobeData = async () => {
  try {
    const adobeLMSURL = '/v2/user/adobelms/newSuggestions';
    let response = await fetch(global.config.PLATFORM_API_URL + adobeLMSURL);
    let responseJson = await response.json();
    console.log('responseJson---->', responseJson);
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getGAPopularSearches = async () => {
  try {
    const url = '/v2/user/ga/popularSearches';
    let response = await fetch(global.config.PLATFORM_API_URL + url);
    let responseJson = await response?.json();
    return responseJson?.data || [];
  } catch (error) {
    console.error(error);
    return null;
  }
}

const retrievePastEvents = async () => {
  try {
    const adobeLMSURL = '/v2/user/adobelms/pastevents';
    let response = await fetch(global.config.PLATFORM_API_URL + adobeLMSURL);
    let responseJson = await response.json();
    console.log('Past Event responseJson---->', responseJson);
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
}

const retrieveEventLocationData = async (zipcode, miles) => {
  try {
    const url = `/v2/user/zipCodesByMiles?zipcode=${zipcode}&miles=${miles}`;
    let response = await fetch(global.config.PLATFORM_API_URL + url);
    let responseJson = await response.json();
    console.log('responseJson---->', responseJson);
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const retrieveIncentive= async (language) => {
  const ms = Date.now();
  try {
    console.log("global.config");
    console.log(global.config);
    let response = await fetch(global.config.AEM_URL + "static-contents/incentives/incentives_"+language+".json?t="+ms);
    console.log('response---->', response);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const retrieveNetworking= async (language) => {
  const ms = Date.now();
  try {
    console.log("global.config");
    console.log(global.config);
    let response = await fetch(global.config.AEM_URL + "static-contents/networking/networking_"+language+".json?t="+ms);
    console.log('response---->', response);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getPopularTipIds= async (topicType) => {
  const ms = Date.now();
  try {
    let response = await fetch(global.config.PLATFORM_API_URL + `/v2/user/adobelms/quicktipsViewCount?topic=${topicType}`);
    let responseJson = await response.json();
    return responseJson.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getRecommendedCourses= async()=> {
  try {
    console.log("global.config");
    console.log(global.config);
    let response = await fetch(global.config.AEM_URL + "static-contents/dashboardjson/recommendedCourses.json")
    console.log('response---->', response);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
}

// const getQuickTipForcedRanking = async(language) => {
//   const current = Date.now();
//   let url = global.config.AEM_URL + "static-contents/dashboardjson/forcedRanking.json?t="+current;
//   switch(language){
//     case "en":
//       url = global.config.AEM_URL + "static-contents/dashboardjson/forcedRanking.json?t="+current;
//       break;
//     case "es":
//       url = global.config.AEM_URL + "static-contents/dashboardjson/forcedRankingSpanish.json?t="+current;
//       break;
//   }
//    try {
//     let response = await fetch(url)
//     console.log('response---->', response);
//     let responseJson = await response.json();
//     return responseJson;
//    } catch (error) {
//      console.log(error);
//      return null;
//    }
// }

const retrieveLearningPathDetailFromAEM= async (language) => {
  const ms = Date.now();
  try {
    console.log("global.config");
    console.log(global.config);
    let path = "learningPath";
      switch (language) {
        case "es":
          path = "learningPath_es";
          break;
      }
    let response = await fetch(global.config.AEM_URL + `static-contents/dashboardjson/${path}.json?t=`+ms);
    console.log('response---->', response);
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// API for the simple search in category/courses 
const getLMSSearchResult = async (resouceType, searchText="")=>{
  let url
  console.log('global.config lms',global.config.PLATFORM_API_URL);
  const lng = localStorage.getItem("lng");
  switch(resouceType) {
    case "Course":
      url = `/v2/user/search?query=${searchText}&loTypes=course&sort=relevance&loFormat=Self Paced&fetchAll=true&language=es-ES,en-US`
      break;
    case "Event":
      url = `/v2/user/search?query=${searchText}&loTypes=course&sort=relevance&loFormat=Self Paced&cursor=${nextCursor}&tagName=${tags}&skillLevel=${skillLevel}&language=es-ES,en-US`
      break;
  }
  
  try{
    let response = await fetch(global.config.PLATFORM_API_URL + url);
    console.log('getlmsSearch response', response);
    let finalresponse = await response.json();
    return finalresponse
  }catch(error){
    console.log(error);
    return null
  }
  }
  
  

  
 
  // API for courses and events banner
  const getInfoHubHtml = async(aemURL) => {
    const requestHtml = {
      method: 'get',
      url: `${aemURL}`,
    };
    try {
      let response = await axios.request(requestHtml);
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

const getLearningPathHtml= async (aemUrl)=>{
  const requestHtml = {
    method: 'get',
    url: aemUrl
  };
  try {
    let response = await axios.request(requestHtml);
    return response;
  } catch(error) {
    console.log(error);
    return null;
  }
}

const retrieveNotificationsData = async (fileName, basePath) => {
  try { 
      let response = await fetch(basePath + fileName);
      console.log('response---->', response);
      let responseJson = await response.json();
      return responseJson;
  } catch (error) {
    console.error("error",error);
  }
};
const decodeHTML = (htmlString) => {
  const parser = new DOMParser();
  const decodedString = parser.parseFromString(htmlString, 'text/html').body.textContent;
  return decodedString;
};

const postVzgptChat = async ({ userId, sessionId, message, vegasId, signal, globalId }) => {
  const response = await fetch(`${global.config.PLATFORM_API_URL}/v2/user/vzgpt/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    signal,
    body: JSON.stringify({
      app_name: 'vbg_sbdr',
      client_Id: 'sbdr-test',
      user_id: userId || '',
      session_id: sessionId || '',
      globalId: globalId || '',
      vegasId: vegasId || '',
      new_message: {
        role: 'user',
        parts: [{ text: message }],
      },
    }),
  });
  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }
  return response;
};

const postSupportClickEvent = async ( visitorId, productId ) => {
  const response = await fetch(`${global.config.RESULTS_API_URL}/onesearch/supportClickEventCapture`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      visitorId: visitorId,
      productDetails: [
        {
          product: {
            id: productId
          }
        }
      ],
    }),
  });
  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }
  return response;
};

const classicSearchResults = async ({ query, source, pageNumber }) => {
    try{
      const response = await fetch(global.config.RESULTS_API_URL + 'onesearch/sbdr/results', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: query, source: source, offset: pageNumber }),
      });
      console.log('classicSearchResults pageNumber:', query);
      if (!response.ok) {
        throw new Error(`API responded with status ${response.status}`);
      }
      const data = await response.json();
      return data?.data || data;
     } catch (error) {
        console.error('Search API error:', error);
      }
}


const postFeedbackForm = async ({ vegasId, topic, description, type }) => {
  const response = await fetch(`${global.config.PLATFORM_API_URL}/v2/user/feedbackForm`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      vegasId,
      topic,
      description,
      type,
    }),
  });
  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }
  return response;
};

export { getInfoHubHtml,retrieveJsonData, retrieveNotificationsData, retrieveAdobeData, retrievePastEvents, retrieveFileData,retrieveIncentive, retrieveNetworking, getPopularTipIds, getRecommendedCourses, retrieveLearningPathDetailFromAEM, getLMSSearchResult,getLearningPathHtml, decodeHTML, retrieveEventLocationData, getGAPopularSearches, postVzgptChat, postSupportClickEvent, classicSearchResults, postFeedbackForm};
